export const environment = {
  apiBasePath: 'http://api.atred.internal:14000',
  defaultLang: 'it',
  production: false,
};
